import { render, staticRenderFns } from "./table-with-add-record.vue?vue&type=template&id=23315dc4&"
import script from "./table-with-add-record.vue?vue&type=script&lang=js&"
export * from "./table-with-add-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports